export default {
  init() {
    // JavaScript to be fired on the home page
    $('.intro-slider').slick({
      draggable: false,
      arrows: true,
      autoplay: false,
      dots: false,
      // centerMode: true,
      // centerPadding: '60px',
      speed: 1400,
      infinite: true,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      touchThreshold: 100,
      // prevArrow: $('.prev'),
      // nextArrow: $('.next'),
      slide: '.item',
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js